export default {
  learn_more_about_donation:
    'https://pebmed.com.br/pebmed-fara-doacao-ao-instituto-da-crianca-para-combater-o-coronavirus/',
  donation_platform: 'https://benfeitoria.com/uniaorio',
};
